<!--
---
--- View: Company Information
---
-->
<template>
    <v-form>
        <MyCompanyDeleteDialog v-if="deleteConfirmationDialogVisible" v-on:hide-company-confirmation-dialog="deleteConfirmationDialogVisible=false" :companyId="companyId"></MyCompanyDeleteDialog>
        <MyCompanyCertificateDialog v-if="certificateDialogVisible" v-on:hide-company-certificate-dialog="certificateDialogVisible=false" :companyId="companyId"></MyCompanyCertificateDialog>
        <v-card>
            <v-alert :value="error!=null" type="error">{{error}}</v-alert>
            <v-container fluid>
                <v-layout justify-space-around fill-height>
                    <v-flex xs11>
                        <v-progress-linear v-if="!company" :indeterminate="processing"/>
                        <v-card hover v-if="company">
                            <v-card-title>
                                <h2>{{$t("attributes.company")}}&nbsp;&nbsp;</h2><h2>{{$t("attributes.certificatePeriod")}} {{edecCertificate.beginDate}}&nbsp;-&nbsp;{{edecCertificate.endDate}}</h2>
                            </v-card-title>

                            <v-radio-group class="my-radio" v-model="company.scheduleMail" :row="true">
                                <v-radio v-for="(item, index) in mailDeliveryOptionsArray" v-bind:key="index" :label="item.title" :value="item.value"/>
                            </v-radio-group>


                            <my-input class="px-3" name="traderIdentificationNumber" :model="company"
                                      :readonly='true'/>
                            <my-input class="px-3" name="customsAccountNumber" :model="company" :readonly='true'/>
                            <my-input class="px-3" name="companyName" :model="company" v-validate="'required'"
                                      :readonly='!isEditable()'/>
                            <my-input class="px-3" name="street" :model="company" v-validate="'required'"
                                      :readonly='!isEditable()'/>
                            <my-input class="px-3" name="zipCode" :model="company" v-validate="'required'"
                                      :readonly='!isEditable()'/>
                            <my-input class="px-3" name="city" :model="company" v-validate="'required'"
                                      :readonly='!isEditable()'/>
                            <my-input class="px-3" name="phone" :model="company" v-validate="'required'"
                                      :readonly='!isEditable()'/>

                            <my-users-combobox :disabled="!isEditable()" :company="company" :usersProp="initialUsers" @users="updateUsers"/>


                            <v-layout row align-center>
                                <v-btn v-if="isEditable()" color="red" @click="deleteConfirmationDialogVisible=true" 
                                    :disabled="processing">{{ $t("attributes.deleteAction") }}
                                </v-btn>

                                <v-btn v-if="isEditable()" color="primary" @click="cancel()" :loading="processing"
                                    :disabled="processing || !saveActive">{{ $t("attributes.cancel") }}
                                </v-btn>

                                <v-btn v-if="isEditable()" color="primary" @click="submit()" :loading="processing"
                                    :disabled="processing || !saveActive">{{ $t("attributes.saveAction") }}
                                </v-btn>

                                <v-btn color="primary" @click="certificateDialogVisible=true">{{ $t("attributes.importCertificate") }}</v-btn>
                            </v-layout>
                        </v-card>
                    </v-flex>

                </v-layout>
            </v-container>
        </v-card>


    </v-form>
</template>

<script>
    import MyInput from '@/components/MyInput.vue'
    import MyUsersCombobox from '@/components/MyUsersCombobox.vue'
    import MyCompanyDeleteDialog from '@/components/MyCompanyDeleteDialog.vue'
    import MyCompanyCertificateDialog from '@/components/MyCompanyCertificateDialog.vue'
    import '@/services/CustomValidations'
    import WebService from "@/services/WebService"
    import EnvService from "@/services/EnvService"
    
    export default {
        name: "my-company",

        components: {
            MyInput, MyUsersCombobox, MyCompanyDeleteDialog, MyCompanyCertificateDialog
        },

        data: () => ({
            company: null,
            processing: false,
            saveActive: false,
            setCompanyRunning: false,
            initialUsers: null,
            usersToUpdate: null,
            webService: new WebService(this),
            deleteConfirmationDialogVisible: false,
            certificateDialogVisible: false,
            edecCertificate: {
                traderIdentificationNumber: null,
                beginDate: null,
                endDate: null
            }
        }),

        mounted() {
            this.processing = true
        },        

        methods: {
            // determine if the user has edit rights !
            isUserAdmin() {
                if (this.$store.state.user == null)
                    return false
                return this.$store.state.user.role == 'ZolldatenUserAdmin'
            },

            // check if the user has admin rights
            isSystemAdmin() {
                if (this.$store.state.user == null)
                    return false
                return this.$store.state.user.role == 'admin';
            },

            // allow editing only for admins
            isEditable() {
                return this.isSystemAdmin() || this.isUserAdmin()
            },


            // update the company information based on the route
            setCompany() {
                // this might be triggered multiple times. we want to run only once
                if (!this.setCompanyRunning) {
                    this.setCompanyRunning = true
                    if (this.company == null || this.companyId != this.company.traderIdentificationNumber) {
                        this.setupCompany()
                    } else {
                        this.processing = false
                        this.saveActive = false
                        this.setCompanyRunning = false
                        this.edecCertificate.traderIdentificationNumber = null
                        this.edecCertificate.beginDate = null
                        this.edecCertificate.endDate = null
                    }
                }
            },

            updateUsers(users) {
                this.usersToUpdate = users
                if (this.usersHaveChanged()) {
                    this.saveActive = true
                }
            },

            usersHaveChanged() {
                return !EnvService.compareArray(this.usersToUpdate, this.initialUsers);
            },

            submit() {
                this.processing = true
                this.$validator.validateAll().then(result => {
                    if (result) {
                        var this_ = this
                        var companyId = this.companyId
                        // post registration data via Axios
                        this.webService.saveCompany(this.company)
                            .then(response => {
                                console.log("response" + response.data)
                                if (response.request.status == 204) {
                                    this_.setCompany()

                                    if (this.usersHaveChanged()) {
                                        // post new or deleted users via Axios
                                        this.webService.saveUserAssignments(companyId, this_.usersToUpdate).then(responseAss => {
                                            if (responseAss.request.status == 204) {
                                                this_.saveActive = false
                                            } else {
                                                // request failed -> display error
                                                this_.$store.dispatch('setError', responseAss)
                                            }
                                        })
                                    } else {
                                        // reload latest info from server
                                        this_.setCompany()
                                        this_.saveActive = false
                                    }
                                    this.processing = false
                                } else {
                                    // request failed -> display error
                                    this.setCompany()
                                    this.$store.dispatch('setError', response.data)
                                }
                            })

                    } else {
                        this.processing = false
                        this.$store.dispatch('setError', this.$t('attributes.missingValues'))
                    }
                });
            },

            cancel() {
                this.setupCompany();
                this.cancelActive = true
                this.saveActive = false
            },

            // read certificate data
            getCertificateData() {
                this.webService.getCertificate(this.companyId)
                    .then(response => {
                        if (response.request.status == 200) {
                            console.log("response" + response.data)
                            this.edecCertificate = response.data
                        } else {
                            this.edecCertificate = {}
                        }
                    }).catch(e => {
                        console.log(e)
                        this.$store.dispatch('setError', e)
                })
            },

            // reset to initial state
            setupCompany(){
                this.processing = true
                this.webService.getCompany(this.companyId)
                    .then(response => {
                        if (response.request.status == 200) {
                            console.log("response" + response.data)
                            this.company = response.data
                            delete this.company.id
                            this.saveActive = false
                            this.getCertificateData()
                        } else {
                            this.$store.dispatch('setError', response)
                            this.company = {}
                        }
                        this.processing = false
                        this.setCompanyRunning = false
                    }).catch(e => {
                        console.log(e)
                        this.processing = false
                        this.$store.dispatch('setError', e)
                        this.setCompanyRunning = false
                })
            }
        },

        computed: {
            // determine the query based on the selection criteria
            companyId: {
                get() {
                    return this.$route.params.companyId;
                }
            },

            // get the companies from vuex
            companies: {
                get() {
                    return this.$store.state.companies
                }
            },

            // determine error message
            error: {
                get() {
                    return this.$store.state.error
                }
            },


            mailDeliveryOptionsArray: function () {
                return [{title: this.$t('attributes.delivery-1'), value:'NoMail'},
                    { title: this.$t('attributes.delivery-2'), value: 'Daily'},
                    { title: this.$t('attributes.delivery-3'), value: 'Weekly'},
                    { title: this.$t('attributes.delivery-4'), value: 'Monthly'}]
            },

        },

        watch: {
            // We activate the save button only when anything was changed
            company: {
                deep: true,
                immediate: false,

                // eslint-disable-next-line
                handler(newVal, oldVal) {
                    // we only consider attribute updates
                    if (oldVal != null && newVal.traderIdentificationNumber == oldVal.traderIdentificationNumber && !this.cancelActive) {
                        this.saveActive = true
                    }
                    this.initialUsers = newVal.users.map(u => u.email)
                    this.cancelActive = false
                }
            },

            // We synchonize the company object
            companyId: {
                immediate: true,
                // eslint-disable-next-line
                handler(newVal, oldVal) {
                    this.setCompany()
                },
            },

            // We synchonize when the companies gets known after the route
            companies: {
                immediate: true,
                // eslint-disable-next-line
                handler(newVal, oldVal) {
                    this.setCompany()
                },
            },

        }


    }
</script>

<style scoped>
    .my-radio {
        padding-left: 20px;
        padding-right: 20px;
    }
</style>
